import { Box } from "@mui/material";
import { runInAction, toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useParams } from "react-router-dom";
import RouterConstants from "../../../../../constants/RouterConstants";
import { useAppStore } from "../../../../../hooks/useStores";
import PlaygroundImages from "../../../../Playground/Images/PlaygroundImages";
import { ViewTgProjectLocationState } from "../../../Projects/Viewer/TgProjectViewer";
import { defaultModel } from "../../store/tg-model-store";
import TgModelEvaluationEmptyState from "./EmptyState/TgModelEvaluationEmptyState";
import TgIntegrateModelBanner from "./IntegrateBanner/TgIntegrateModelBanner";
import styles from "./TgModelEvaluation.module.scss";

const TgModelEvaluation = () => {
	const { t } = useTranslation("tg", { keyPrefix: "models.viewer.evaluation" });
	const location = useLocation();
	const { projectId, modelId } = useParams();
	const { uiStore, tgStore } = useAppStore();
	const { tgProjectStore, tgModelStore, tgModelPlaygroundStore } = tgStore;

	useLayoutEffect(() => {
		tgModelPlaygroundStore.resetPlayground();
	}, []);

	useEffect(() => {
		(async () => {
			const modelToView = location.state?.modelToView || tgModelStore.modelToView;
			if (!modelToView.id && modelId) {
				const model = await tgModelStore.getModel(Number(modelId));
				runInAction(() => {
					tgModelStore.modelToView = model;
				});
			}
		})();

		return () => {
			tgModelStore.modelToView = defaultModel;
			window.history.replaceState({}, "");
		};
	}, []);

	useEffect(() => {
		uiStore.hideSideBar();

		(async () => {
			if (projectId) {
				const viewProjectState: ViewTgProjectLocationState = {
					projectToView: toJS(tgProjectStore.projectToView),
				};

				uiStore.showBackButton(
					`${RouterConstants.NEW_TG.PROJECTS.fullPath}/${projectId}/${RouterConstants.NEW_TG.MODELS.path}`,
					{ state: viewProjectState },
					t(`backButton`, { projectName: tgProjectStore.projectToView.project_name || "Project" }),
				);

				if (isNaN(tgProjectStore.projectToView.id)) {
					const project = await tgProjectStore.getProject(Number(projectId));
					tgProjectStore.projectToView = project;
				}
			}
		})();

		return () => {
			tgModelPlaygroundStore.resetPlayground();
			uiStore.showSideBar();
			uiStore.hideBackButton();
		};
	}, []);

	return (
		<Box className={styles.root}>
			<Outlet />
			<Box className={styles.imagesContainer}>
				<PlaygroundImages emptyState={<TgModelEvaluationEmptyState />} />
				<TgIntegrateModelBanner />
			</Box>
		</Box>
	);
};

export default observer(TgModelEvaluation);
